"use client"

import { BookUser } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BookUserIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BookUserIcon = component(Icon)({ as: BookUser })
